

exports.__esModule = true;
exports.$RedirectToCapeRoute = undefined;

var _squid = require('squid');

require('./directive');

var $RedirectToCapeRoute = exports.$RedirectToCapeRoute = _squid.$ComponentRoute.extend('$RedirectToCapeRoute', {
    path: 'redirectToCape',
    directive: 'xo-redirect-to-cape',
    titleContent: 'redirectToCape',
    params: {
        financing_option: null,
        showCapeCyco: false
    },
    trackingData: {
        fptiState: 'redirect-to-cape',
        buzname: {
            'fullpage': {
                'pagename': '%::redirect-to-cape',
                'pagename2': '%::redirect-to-cape:member:hermes:',
                'version': 'member:%:'
            }
        }
    },
    loginRequired: false,
    auth: false,
    children: []
});

angular.value("$RedirectToCapeRoute", $RedirectToCapeRoute);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-credit-components/src/redirect-to-cape/route.js
// module id = ../node_modules/xo-credit-components/src/redirect-to-cape/route.js
// module chunks = 0